import React, { useRef, useEffect } from 'react';
import { StructuredText, renderRule } from 'react-datocms';
import { isHeading, isListItem } from 'datocms-structured-text-utils';
import { render as toPlainText } from 'datocms-structured-text-to-plain-text';

import Icon from '../../../molecules/Icon';

import GatsbyImage from '../../Image/GatsbyImage';
import CardDeckGenerator from '../../CardDeck';
import ContactCard from '../../Cards/ContactCard';
import ConversionBox from '../../ConversionBox';
import LiteYoutube from '../../Lite-Youtube/LiteYoutube';

import { getYoutubeId } from '../../../utils/getYoutubeId';
import getTableData from '../utils/getTableData';

import { color } from '../../../atoms/colors';
import {
  Asset,
  CardDeckWrapper,
  Container,
  ConversionWrapper,
  ListItem,
} from '../styles/StructuredText';

const StructuredTextComponent = ({ component, contactInfo, setTableData }) => {
  const contentRef = useRef();
  useEffect(() => setTableData(getTableData(contentRef)), [contentRef]);

  if (!component?.value) return null;
  return (
    <Container ref={contentRef} className="track-progress">
      <StructuredText
        data={component}
        customNodeRules={
          component?.value && [
            renderRule(isHeading, ({ node, children, key }) => {
              const HeadingTag = `h${node.level}`;
              const anchor = toPlainText(node)
                .toLowerCase()
                .replace(/ /g, '-')
                .replace(/[^\w-]+/g, '');
              const label =
                typeof children[0] === 'object'
                  ? children[0]?.props?.children[0]
                  : children[0];
              return (
                <HeadingTag
                  id={anchor}
                  key={key}
                  data-anchor={anchor}
                  data-tag={HeadingTag}
                  data-label={label}
                >
                  {children}
                </HeadingTag>
              );
            }),
            renderRule(isListItem, ({ children, key }) => (
              <ListItem key={key}>
                <Icon
                  id="circle-check-01"
                  fillColor={color.blue[700]}
                  styles={`
                    min-width: 24px; 
                    max-width: 24px; 
                    min-height: 24px; 
                    max-height: 24px;
                  `}
                />
                {children}
              </ListItem>
            )),
          ]
        }
        renderInlineRecord={({ record, key }) => {
          switch (record.internal?.type) {
            case 'DatoCmsWebsiteImage':
              return (
                <Asset key={key}>
                  <GatsbyImage
                    src={record?.image?.gatsbyImageData}
                    alt={record?.alt}
                  />
                </Asset>
              );
            case 'DatoCmsWebsiteVideo':
              return (
                <Asset key={key}>
                  <LiteYoutube videoId={getYoutubeId(record?.youtubeUrl)} />
                </Asset>
              );
            case 'DatoCmsCardDeckComponent':
              return (
                <CardDeckWrapper>
                  <CardDeckGenerator key={key} component={record} />
                </CardDeckWrapper>
              );
            case 'DatoCmsConversionBox':
              return (
                <ConversionWrapper>
                  <ConversionBox
                    key={key}
                    component={record}
                    theme={record?.theme}
                  />
                </ConversionWrapper>
              );
            default:
              return null;
          }
        }}
      />
      {contactInfo && (
        <ContactCard
          email={contactInfo?.email}
          phoneNumber={contactInfo?.phoneNumber}
        />
      )}
    </Container>
  );
};

export default StructuredTextComponent;
